import { rescueModalUiButtonSubtextSchema } from "@redotech/redo-model/checkouts/predictive-conversion-settings";
import { zUsdCents } from "@redotech/redo-model/currency";
import * as z from "zod/v4";

const getUsageBillingSettings = z.object({
  kind: z.literal("usage"),
  enabled: z.boolean(),
  startDate: z.date().optional(),
  pricePerOrderInCents: z.number(),
  // Exists with date if renewOnPeriodEnd is false
  usageBillingEndDate: z.date().optional(),
  billingAccepted: z.boolean(),
  billIntentActiveOrders: z.boolean().optional(),
});

const getSubscriptionBillingSettings = z.object({
  kind: z.literal("subscription"),
  enabled: z.boolean(),
  startDate: z.date().optional(),
  periodFeeInCents: zUsdCents,
  pricePerOrderInCents: zUsdCents.optional(),
  // Exists with date if renewOnPeriodEnd is false
  billingAccepted: z.boolean(),
  billIntentActiveOrders: z.boolean().optional(),
});

export const getConversionSettings = {
  name: "getConversionSettings" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    checkoutOptimizationEnabled: z.boolean(),
    checkoutOptimizationBilling: z
      .union([getUsageBillingSettings, getSubscriptionBillingSettings])
      .optional(),
    predictiveConversion: z
      .object({
        enabled: z.boolean(),
        intentRequested: z.boolean(),
        rescueModalAdminSettings: z.object({
          uiButtonSubtext: rescueModalUiButtonSubtextSchema,
        }),
      })
      .optional(),
    postPurchaseUpsell: z
      .object({ createOrderOnUpsell: z.boolean() })
      .optional(),
    ensureDiscountsCombineWithShippingDiscounts: z.boolean().optional(),
  }),
};
